import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { GlobalConstants } from 'src/app/common/global-constants';
import { IssueTrackModel } from '../models/issue.model';
import { UserService } from './user.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class IssueTrackService {
  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/IssueTracks";

    constructor(private http : HttpClient, private userservice : UserService) {
      console.log("constructor : ClientService ");
      this.BaseURI = window.location.origin + "/api";
    }
     getDetail(id)
     {
        return this.http.get(this.BaseURI + this.apiController + "/" + id);
     }

     getList()
     {
        return this.http.get(this.BaseURI + this.apiController);
      }

     insertData(item : IssueTrackModel) {

      item.createBy = this.userservice.getUserID();

       return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["trackId", "createTime"]));
     }

     updateData(item : IssueTrackModel) {
       return this.http.put(this.BaseURI + this.apiController + "/" + item.issueId, item);
     }


     deleteData(id)
     {
       return this.http.delete(this.BaseURI + this.apiController + "/" + id);

     }

     findDataByIssue(id)
   {
     return this.http.get(this.BaseURI + this.apiController + "/FindByIssue?id=" + id);
   }

   findDataByCall(id)
   {
     return this.http.get(this.BaseURI + this.apiController + "/FindByCall?id=" + id);
   }

   getIssueFileList(id)
    {

      return this.http.get(this.BaseURI + this.apiController + "/GetAttachedFileList?id=" + id);
   }
}
